﻿export class InquiryRequest {
    public FullName : string;
    public Phone : string;
    public Email : string;
    public Message : string;
    public PDID: string;
    public ListingUID: string;
}